<div class="container">
  <div class="header"></div>
  <div class="body">
    <table class="errors-table">
      <thead>
        <tr>
          <th>Time</th>
          <th>Availability Zone</th>
          <th>Channel Name</th>
          <th>Platform Name</th>
          <th>Count</th>
          <th>Severity</th>
          <th>Message</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let error of vm.errors"
          [ngClass]="{ 'new-error': error.isNew }"
        >
          <td>{{ vm.formatTime(error.createdTime) }}</td>
          <td>{{ error.availabilityZoneName }}</td>
          <td>{{ error.channelName }}</td>
          <td>{{ error.platformName }}</td>
          <td>{{ error.count }}</td>
          <td>{{ error.severity }}</td>
          <td>{{ error.msg }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
